// axios
import axios from 'axios'
import config from './config'
export default axios.create({
  baseURL: config.getConfig().baseurl,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `${localStorage.getItem("accessToken")}`
  }
})







